import { REFERRAL_LINK_BASE_URL } from '../config';

export const getReferralLink = (organizationID: string) =>
  `${REFERRAL_LINK_BASE_URL}?start-with-diagnocat&referrer=${encodeURIComponent(organizationID)}`;

export const getDisplayedReferralLink = (link: string) =>
  link.replace(/^https?:\/\//, '');
